import { render } from "./ResearchActivities.vue?vue&type=template&id=dde597ba&ts=true"
import script from "./ResearchActivities.vue?vue&type=script&lang=ts"
export * from "./ResearchActivities.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__